var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCaret = function SvgCaret(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 7,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFB81C",
    fillRule: "evenodd",
    d: "M.431.997a.844.844 0 0 1 1.193 0l3.06 3.06 3.06-3.06A.844.844 0 1 1 8.936 2.19L5.28 5.846a.844.844 0 0 1-1.192 0L.43 2.19a.844.844 0 0 1 0-1.193Z",
    clipRule: "evenodd"
  })));
};
export default SvgCaret;